<template>
  <div>
    <div style="background-color: #fff; padding-bottom: 30px">
      <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img :src="
              app.application.membership.membershipName == 'Familiar' &&
                app.maritalStatus == 'MARRIED'
                ? '/img/tree/Wizard2-Conyuge-07.svg'
                : '/img/tree/Wizard2-Soltero-06.svg'
            " style="width: 100%; height: auto" alt />
          </div>
        </mdb-row>
      </mdb-container>
    </div>
    <div style="background-color: #f7f7f7" class="mt-1 pt-1 cardClass">
      <mdb-container style="
          max-width: 97% !important;
          padding-bottom: 2rem;
          background-color: #fff;
          -webkit-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
          -moz-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
          box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
        " class="mt-5">
        <mdb-row class="pt-5 pr-5">
          <mdb-col md="8" class="text-center">
            <span class="text-style"></span>
          </mdb-col>
          <mdb-col md="1" class="text-right" style="margin-left: 24%">
            <p style="
                font-size: 30px;
                cursor: pointer;
                color: #e0e0e0;
                font-weight: 700;
              " @click="closeMessageError()">
              x
            </p>
          </mdb-col>
        </mdb-row>

        <div class="documents-section mb-5">
          <!-- SECCIÓN DATOS PERSONALES ========================== -->
          <div class="info mb-3">
            <div class="t1-table-title-left text-uppercase">Corregir Datos</div>
            <div class="t1-subtitle" style="font-size: 18px">
              Estimado solicitante, favor de realizar las siguientes correciones
              de documentos y/o datos que se señalan a continuación
            </div>
            <mdb-row class="mt-5">
              <mdb-col md="9">
                <div class="Rectangle-78" style="font-size: 15px; text-transform: uppercase;">
                  <p style="font-size: 15px; font-weight: 600; color: #000;">Titular</p>
                  <ul v-for="doc in app.documents" :key="doc.id">
                    <li v-if="doc.documentType == 'PROOF_OF_ADDRESS' && doc.comment">
                      {{ doc.comment }}
                    </li>
                  </ul>
                  <ul>
                    <li v-if="app.billingInformation.comment">
                      {{ app.billingInformation.comment }}
                    </li>
                  </ul>
                  <p style="font-size: 15px; font-weight: 600; color: #000;">Automoviles</p>
                  <ul v-for="doc in app.documents" :key="doc.id">
                    <li v-if="doc.documentType == 'CAR_BILL' && doc.comment">
                      {{ doc.comment }}
                    </li>
                  </ul>
                  <p v-if="spouseData" style="font-size: 15px; font-weight: 600; color: #000;">Cónyuge</p>
                  <div v-if="spouseData">
                    <ul v-for="doc in spouseData[0].documents" :key="doc.id">
                      <li v-if="doc.documentType == 'PROOF_OF_ADDRESS' && doc.comment">
                        {{ doc.comment }}
                      </li>
                    </ul>

                  </div>
                  <div v-if="beneficiaries != null">
                    <div v-for="benef in beneficiaries" :key="benef.id">
                      <p style="font-size: 15px; font-weight: 600; color: #000;">Hijos</p>
                      <ul v-for="doc in benef.documents" :key="doc.id">
                        <li v-if="doc.comment">
                          {{ doc.comment }}
                        </li>

                      </ul>
                      <ul v-if="benef.laborData && benef.laborData.comment">
                        <li>{{ benef.laborData.comment }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row class="mt-5 text-center">
              <mdb-col md="9">
                <span style="font-size: 14px; font-weight: 600; color: red">POR FAVOR, SUBE E INGRESA SOLO LOS DATOS QUE
                  SE TE
                  MENCIONAN</span>
              </mdb-col>
            </mdb-row>
          </div>
          <div class="accordion-section">
            <div style="font-size: 18px; font-weight: 600">
              Fecha de generación de Solicitud:
              {{ app.application.createdAt.split(" ")[0] }}
            </div>
            <!--TITULAR-->
            <Accordion title="Titular" id="titular" :key="'titular'">
              <div class="accordion-header">Solicitud</div>
              <div class="accordion-content">
                <mdb-row>
                  <mdb-col md="12">
                    <mdb-row>
                      <mdb-col md="4">
                        <div v-for="item in app.documents" :key="item.id">
                          <img v-if="item.documentType == 'PROFILE_PICTURE'" class="avatar-pic" :src="item.publicURL"
                            alt="Profile Picture" @click="openModal(item.publicURL, 'Foto titular')" />
                          <div v-if="item.documentType == 'PROFILE_PICTURE'" class="zoom-pic"
                            @click="openModal(item.publicURL, 'Foto titular')"></div>
                        </div>
                      </mdb-col>
                      <mdb-col v-if="app.application.applicationNumber" md="4">
                        <label for="input_appN" class="form__label">No. de solicitud:</label>
                        <input type="text" id="input_appN" class="form__input"
                          v-model="app.application.applicationNumber" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.application.payment" md="4">
                        <label for="input_pay_date" class="form__label">Fecha de pago:</label>
                        <input type="text" id="input_pay_Date" class="form__input"
                          v-model="app.application.payment.date" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col v-if="app.name" md="4">
                        <label for="input_name" class="form__label">Nombre:</label>
                        <input type="text" id="input_name" class="form__input" v-model="app.name" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.lastName" md="4">
                        <label for="input_lastname" class="form__label">Apellido parterno:</label>
                        <input type="text" id="input_lastname" class="form__input" v-model="app.lastName" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.mothersLastName" md="4">
                        <label for="input_Mlastname" class="form__label">Apellido materno:</label>
                        <input type="text" id="input_Mlastname" class="form__input" v-model="app.mothersLastName"
                          disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col v-if="
                        app.application.applicantType.applicationTypeValue
                      " md="4">
                        <label for="input_name" class="form__label">Tipo de usuario:</label>
                        <input type="text" id="input_name" class="form__input" v-model="
                          app.application.applicantType.applicantTypeValue
                        " disabled />
                      </mdb-col>
                      <mdb-col v-if="app.application.proceedingType" md="4">
                        <label for="input_lastname" class="form__label">Tipo de trámite:</label>
                        <input type="text" id="input_lastname" class="form__input" v-model="
                          app.application.proceedingType.proceedingTypeValue
                        " disabled />
                      </mdb-col>
                      <mdb-col v-if="app.application.subProceedingType" md="4">
                        <label for="input_subProceeding" class="form__label">Tipo de venta</label>
                        <input type="text" id="input_subProceeding" class="form__input" v-model="
                          app.application.subProceedingType
                            .subProceedingTypeValue
                        " disabled />
                      </mdb-col>
                      <mdb-col v-if="app.application.membership" md="4">
                        <label for="input_Mlastname" class="form__label">Tipo de acción</label>
                        <input type="text" id="input_Mlastname" class="form__input"
                          v-model="app.application.membership.membershipName" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row v-show="
                      app.application.applicantType.applicantTypeValue ==
                      'Propietario'
                    " class="mt-3">
                      <mdb-col v-show="false" md="4">
                        <label for="input_name" class="form__label">Titular de la propiedad:</label>
                        <input type="text" id="input_name" class="form__input" disabled />
                      </mdb-col>
                      <mdb-col md="4"></mdb-col>
                      <mdb-col md="4"></mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col v-if="app.application.seller" md="8">
                        <label for="input_name" class="form__label">Nombre del asesor de ventas:</label>
                        <input type="text" id="input_name" class="form__input" v-model="app.application.seller"
                          disabled />
                      </mdb-col>
                      <mdb-col v-if="app.application.payment.total" md="4">
                        <label for="input_lastname" class="form__label">Total pagado:</label>
                        <input type="text" id="input_lastname" class="form__input"
                          v-model="app.application.payment.total" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col md="4">
                        <div v-for="item in app.documents" :key="item.id">
                          <Btn v-if="item.documentType == 'DEED_OR_AGREEMENT'" :text="'Escrituras'" icon="revisar"
                            :type="'primary-admin'" @onClick="openModal(item.publicURL, 'Escrituras')"></Btn>
                        </div>
                      </mdb-col>
                      <mdb-col md="6">
                        <div v-for="item in app.documents" :key="item.id">
                          <Btn v-if="item.documentType == 'PROPERTY_PAYMENT'" :text="'Pago de predial'" icon="revisar"
                            :type="'primary-admin'" @onClick="openModal(item.publicURL, 'Pago predial')"></Btn>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
              </div>

              <div class="accordion-header">Personales</div>
              <div class="accordion-content">
                <mdb-row>
                  <mdb-col md="12">
                    <mdb-row>
                      <mdb-col v-if="app.birthDate" md="6">
                        <label for="input_appN" class="form__label">Fecha de nacimiento:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="app.birthDate" disabled />
                      </mdb-col>
                      <mdb-col md="2">
                        <label for="input_appN" class="form__label">Edad:</label>
                        <input type="text" id="input_appN" class="form__input" :value="edad" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col md="6">
                        <label for="input_name" class="form__label">Estado civil:</label>
                        <input type="text" id="input_name" class="form__input" :value="marital" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.exSpouseFullName" md="6">
                        <label for="input_lastname" class="form__label">Nombre ex espos@:</label>
                        <input type="text" id="input_lastname" class="form__input" v-model="app.exSpouseFullName"
                          disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <!-- <mdb-col md="6">
                      <div v-for="item in app.documents" :key="item.id">
                        <label
                          v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"
                          for="input_name"
                          class="form__label"
                        >INE/PASAPORTE:</label>
                        <input
                          v-if="item.documentType=='INE'||item.documentType=='PASSPORT'"
                          type="text"
                          id="input_name"
                          :value="item.value"
                          class="form__input"
                          disabled
                        />
                      </div>
                    </mdb-col>-->
                      <mdb-col md="6">
                        <div v-for="item in app.documents" :key="item.id">
                          <label v-if="item.documentType == 'CURP'" for="input_name" class="form__label">CURP:</label>
                          <input v-if="item.documentType == 'CURP'" type="text" id="input_name" :value="item.value"
                            class="form__input" disabled />
                        </div>
                      </mdb-col>
                      <mdb-col md="4"></mdb-col>
                    </mdb-row>

                    <mdb-row class="mt-3">
                      <mdb-col md="4">
                        <div v-for="item in app.documents" :key="item.id">
                          <Btn v-if="
                            item.documentType == 'INE' ||
                            item.documentType == 'PASSPORT'
                          " :text="'IDENTIFICACIÓN OFICIAL'" icon="revisar" :type="'primary-admin'" @onClick="
  openModal(
    item.publicURL,
    'Identificación Oficial'
  )
"></Btn>
                        </div>
                      </mdb-col>
                      <mdb-col md="3">
                        <div v-for="item in app.documents" :key="item.id">
                          <Btn v-if="item.documentType == 'CURP'" :text="'CURP'" icon="revisar" :type="'primary-admin'"
                            @onClick="openModal(item.publicURL, 'CURP')"></Btn>
                        </div>
                      </mdb-col>
                      <mdb-col md="5">
                        <div v-for="item in app.documents" :key="item.id">
                          <Btn v-if="item.documentType == 'BIRTH_CERTIFICATE'" :text="'ACTA DE NACIMIENTO'"
                            icon="revisar" :type="'primary-admin'" @onClick="
                              openModal(item.publicURL, 'Acta de nacimiento')
                            "></Btn>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
              </div>

              <div class="accordion-header">De Contacto</div>
              <div class="accordion-content">
                <mdb-row>
                  <mdb-col md="16">
                    <mdb-row>
                      <mdb-col md="8">
                        <label for="input_appN" class="form__label">Correo electrónico:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="app.personalMail" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <div v-for="(item, index) in app.phones" :key="index">
                        <mdb-col md="9" v-if="item.phoneType == 'Celular'">
                          <label for="input_appN" class="form__label">Télefono celular:</label>
                          <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                        </mdb-col>
                        <mdb-col v-if="item.phoneType == 'Casa'" md="9">
                          <label for="input_appN" class="form__label">Télefono casa:</label>
                          <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                        </mdb-col>
                        <mdb-col v-if="item.phoneType == 'Oficina'" md="9">
                          <label for="input_appN" class="form__label">Télefono oficina:</label>
                          <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                        </mdb-col>
                      </div>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
              </div>

              <!--DE DOMICILIO-->
              <div class="accordion-header">Domicilio</div>
              <div class="accordion-content">
                <mdb-row>
                  <mdb-col md="12">
                    <mdb-row>
                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">Estado:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressT.state" disabled />
                      </mdb-col>

                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">Ciudad:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressT.city" disabled />
                      </mdb-col>
                      <mdb-col md="2">
                        <label for="input_appN" class="form__label">C. P.:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressT.zipCode" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">Colonia:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressT.colony" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.address.street" md="4">
                        <label for="input_appN" class="form__label">Calle:</label>
                        <input type="text" id="input_appN" class="form__input" :value="app.address.street" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.address.externalNumber" md="2">
                        <label for="input_appN" class="form__label">No. Ext.:</label>
                        <input type="text" id="input_appN" class="form__input" :value="app.address.externalNumber"
                          disabled />
                      </mdb-col>
                      <mdb-col md="2">
                        <label for="input_appN" class="form__label">No. Int.:</label>
                        <input type="text" id="input_appN" class="form__input" :value="app.address.interiorNumber"
                          disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col md="8">

                        <Btn v-if="titularProofAddress.publicURL" :text="'Comprobante de domicilio'" icon="revisar"
                          :type="'primary-admin'" @onClick="
                            openModal(
                              titularProofAddress.publicURL,
                              'Comprobante de domicilio'
                            )
                          "></Btn>
                        <button v-if="titularProofAddress.publicURL" type="button" class="btn btn-delete"
                          @click="titularProofAddress.publicURL = null"
                          style="padding: 3px; position: inherit; top: 4px">
                          <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                        </button>
                        <div v-else>
                          <label for="curp-input" class="btn-label">
                            <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                            SUBIR NUEVO COMPROBANTE
                          </label>
                          <input type="file" accept="application/pdf" name="file" id="curp-input"
                            style="visibility: hidden" @change="uploadDocument(titularProofAddress, $event)" />
                        </div>

                      </mdb-col>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
              </div>

              <div v-for="(item, index) in app.phones" :key="index">
                <div v-if="item.phoneType == 'Emergency'" class="accordion-header">
                  Contacto de emergencia
                </div>

                <div v-if="item.phoneType == 'Emergency'" class="accordion-content">
                  <mdb-row>
                    <mdb-col md="12">
                      <mdb-row>
                        <mdb-col md="12">
                          <label for="input_appN" class="form__label">Nombre del contacto:</label>
                          <input type="text" id="input_appN" class="form__input" :value="item.contactName" disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <mdb-col md="4">
                          <label for="input_appN" class="form__label">Parentesco:</label>
                          <input type="text" id="input_appN" class="form__input" :value="item.contactRelationship"
                            disabled />
                        </mdb-col>
                        <mdb-col md="4">
                          <label for="input_appN" class="form__label">Télefono celular:</label>
                          <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                        </mdb-col>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </div>
              </div>

              <!-- LABORALES-->
              <div class="accordion-header">Laborales</div>
              <div class="accordion-content">
                <mdb-row>
                  <mdb-col md="12">
                    <mdb-row>
                      <mdb-col v-if="app.laborData.company" md="8">
                        <label for="input_appN" class="form__label">Nombre de la empresa o lugar de trabajo:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="app.laborData.company"
                          disabled />
                      </mdb-col>
                      <mdb-col v-if="app.laborData.phone" md="4">
                        <label for="input_appN" class="form__label">Teléfono de la empresa:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="app.laborData.phone" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col v-if="app.laborData.position" md="8">
                        <label for="input_appN" class="form__label">Puesto que desempeña:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="app.laborData.position"
                          disabled />
                      </mdb-col>
                      <mdb-col md="4"></mdb-col>
                    </mdb-row>

                    <mdb-row class="mt-3">
                      <mdb-col md="6">
                        <div v-for="item in app.documents" :key="item.id">
                          <Btn v-if="item.documentType == 'TAX_STATUS_LETTER'" :text="'CONSTANCIA DE SITUACIÓN FISCAL'"
                            icon="revisar" :type="'primary-admin'" @onClick="
                              openModal(
                                item.publicURL,
                                'Constancia de situación fiscal'
                              )
                            "></Btn>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
              </div>

              <div v-if="app.billingInformation != null" class="accordion-header">
                Datos de facturación
              </div>
              <div v-if="app.billingInformation != null" class="accordion-content">
                <mdb-row>
                  <mdb-col md="12">
                    <mdb-row>
                      <mdb-col md="8">
                        <label for="input_appN" class="form__label">Nombre o razón social:</label>
                        <input type="text" id="input_appN" class="form__input"
                          v-model="billingInformation.businessSocialReason" />
                      </mdb-col>
                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">RFC:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="billingInformation.rfc" />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col md="10">
                        <div class="form__group">
                          <label class="form__label" style="cursor: unset !important">
                            |
                            <b>DOMICILIO DE FACTURACIÓN</b>
                          </label>
                        </div>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">Estado:</label>
                        <input type="text" id="input_appN" class="form__input" v-model="addressBill.state" disabled />
                      </mdb-col>

                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">Ciudad:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressBill.city" disabled />
                      </mdb-col>
                      <mdb-col md="2">
                        <label for="input_appN" class="form__label">C. P.:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressBill.zipCode" disabled />
                      </mdb-col>
                    </mdb-row>
                    <mdb-row class="mt-3">
                      <mdb-col md="4">
                        <label for="input_appN" class="form__label">Colonia:</label>
                        <input type="text" id="input_appN" class="form__input" :value="addressBill.colony" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.billingInformation.address.street" md="4">
                        <label for="input_appN" class="form__label">Calle:</label>
                        <input type="text" id="input_appN" class="form__input"
                          :value="app.billingInformation.address.street" disabled />
                      </mdb-col>
                      <mdb-col v-if="app.billingInformation.address.externalNumber" md="2">
                        <label for="input_appN" class="form__label">No. Ext.:</label>
                        <input type="text" id="input_appN" class="form__input"
                          :value="app.billingInformation.address.externalNumber" disabled />
                      </mdb-col>
                      <mdb-col md="2">
                        <label for="input_appN" class="form__label">No. Int.:</label>
                        <input type="text" id="input_appN" class="form__input"
                          :value="app.billingInformation.address.interiorNumber" disabled />
                      </mdb-col>
                    </mdb-row>
                  </mdb-col>
                </mdb-row>
              </div>
            </Accordion>

            <Accordion v-if="
              app.maritalStatus == 'MARRIED' &&
              app.application.membership.membershipName == 'Familiar'
            " :key="'conyuge'" id="conyuge" title="Cónyuge">
              <!---->
              <div class="accordion-header">Personales</div>
              <div class="accordion-content">
                <div class="accordion-content">
                  <mdb-row>
                    <mdb-col md="12">
                      <mdb-row>
                        <mdb-col md="4">
                          <div v-for="item in spouseData[0].documents" :key="item.id">
                            <img v-if="item.documentType == 'PROFILE_PICTURE'" class="avatar-pic" :src="item.publicURL"
                              alt="Profile Picture" @click="openModal(item.publicURL, 'Foto cónyuge')" />
                            <div v-if="item.documentType == 'PROFILE_PICTURE'" class="zoom-pic"
                              @click="openModal(item.publicURL, 'Foto titular')"></div>
                          </div>
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].birthDate" md="4">
                          <label for="input_appN" class="form__label">Fecha de nacimiento:</label>
                          <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].birthDate"
                            disabled />
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].birthPlace" md="4">
                          <label for="input_appN" class="form__label">Entidad de nacimiento:</label>
                          <input type="text" id="input_appN" class="form__input" :value="spouseData[0].birthPlace"
                            disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <mdb-col v-if="spouseData[0].name" md="4">
                          <label for="input_name" class="form__label">Nombre:</label>
                          <input type="text" id="input_name" class="form__input" :value="spouseData[0].name" disabled />
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].lastName" md="4">
                          <label for="input_lastname" class="form__label">Apellido paterno:</label>
                          <input type="text" id="input_lastname" class="form__input" :value="spouseData[0].lastName"
                            disabled />
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].mothersLastName" md="4">
                          <label for="input_lastname" class="form__label">Apellido materno:</label>
                          <input type="text" id="input_lastname" class="form__input"
                            :value="spouseData[0].mothersLastName" disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <mdb-col md="6">
                          <div v-for="item in spouseData[0].documents" :key="item.id">
                            <label v-if="item.documentType == 'CURP'" for="input_name" class="form__label">CURP:</label>
                            <input v-if="item.documentType == 'CURP'" type="text" id="input_name" :value="item.value"
                              class="form__input" disabled />
                          </div>
                        </mdb-col>
                        <mdb-col md="4"></mdb-col>
                      </mdb-row>

                      <mdb-row class="mt-3">
                        <mdb-col md="4">
                          <div v-for="item in spouseData[0].documents" :key="item.id">
                            <Btn v-if="
                              item.documentType == 'INE' ||
                              item.documentType == 'PASSPORT'
                            " :text="'IDENTIFICACIÓN OFICIAL'" icon="revisar" :type="'primary-admin'" @onClick="
  openModal(
    item.publicURL,
    'Indentificación Oficial'
  )
"></Btn>
                          </div>
                        </mdb-col>
                        <mdb-col md="3">
                          <div v-for="item in spouseData[0].documents" :key="item.id">
                            <Btn v-if="item.documentType == 'CURP'" :text="'CURP'" icon="revisar"
                              :type="'primary-admin'" @onClick="openModal(item.publicURL, 'CURP')"></Btn>
                          </div>
                        </mdb-col>
                        <mdb-col md="5">
                          <div v-for="item in spouseData[0].documents" :key="item.id">
                            <Btn v-if="item.documentType == 'BIRTH_CERTIFICATE'" :text="'ACTA DE NACIMIENTO'"
                              icon="revisar" :type="'primary-admin'" @onClick="
                                openModal(item.publicURL, 'Acta de nacimiento')
                              "></Btn>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </div>

                <div class="accordion-header">Datos laborales</div>
                <div class="accordion-content">
                  <mdb-row>
                    <mdb-col md="12">
                      <mdb-row>
                        <mdb-col v-if="spouseData[0].laborData.company" md="8">
                          <label for="input_appN" class="form__label">Nombre de la empresa o lugar de trabajo:</label>
                          <input type="text" id="input_appN" class="form__input"
                            v-model="spouseData[0].laborData.company" disabled />
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].laborData.phone" md="4">
                          <label for="input_appN" class="form__label">Teléfono de la empresa:</label>
                          <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].laborData.phone"
                            disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <mdb-col v-if="spouseData[0].laborData.position" md="8">
                          <label for="input_appN" class="form__label">Puesto que desempeña:</label>
                          <input type="text" id="input_appN" class="form__input"
                            v-model="spouseData[0].laborData.position" disabled />
                        </mdb-col>
                        <mdb-col md="4"></mdb-col>
                      </mdb-row>

                      <mdb-row class="mt-3">
                        <mdb-col md="6">
                          <div v-for="item in spouseData[0].documents" :key="item.id">
                            <Btn v-if="item.documentType == 'TAX_STATUS_LETTER'"
                              :text="'CONSTANCIA DE SITUACIÓN FISCAL'" icon="revisar" :type="'primary-admin'" @onClick="
                                openModal(
                                  item.publicURL,
                                  'Constancia de situación fiscal'
                                )
                              "></Btn>
                          </div>
                        </mdb-col>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </div>

                <div class="accordion-header">De contacto</div>
                <div class="accordion-content">
                  <mdb-row>
                    <mdb-col md="12">
                      <mdb-row>
                        <mdb-col md="8">
                          <label for="input_appN" class="form__label">Correo electrónico:</label>
                          <input type="text" id="input_appN" class="form__input" v-model="spouseData[0].personalMail"
                            disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <div v-for="(item, index) in spouseData[0].phones" :key="index">
                          <mdb-col md="9" v-if="item.phoneType == 'Celular'">
                            <label for="input_appN" class="form__label">Télefono celular:</label>
                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                          </mdb-col>
                          <mdb-col v-if="item.phoneType == 'Casa'" md="9">
                            <label for="input_appN" class="form__label">Télefono casa:</label>
                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                          </mdb-col>
                          <mdb-col v-if="item.phoneType == 'Oficina'" md="9">
                            <label for="input_appN" class="form__label">Télefono oficina:</label>
                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                          </mdb-col>
                        </div>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </div>

                <div v-if="addressBenef.length > 0" class="accordion-header">
                  Domicilio
                </div>
                <div v-if="addressBenef.length > 0" class="accordion-content">
                  <mdb-row>
                    <mdb-col md="12">
                      <mdb-row>
                        <mdb-col md="4">
                          <label for="input_appN" class="form__label">Estado:</label>
                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[0].state"
                            disabled />
                        </mdb-col>

                        <mdb-col md="4">
                          <label for="input_appN" class="form__label">Ciudad:</label>
                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[0].city"
                            disabled />
                        </mdb-col>
                        <mdb-col md="2">
                          <label for="input_appN" class="form__label">C. P.:</label>
                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[0].zipCode"
                            disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <mdb-col md="4">
                          <label for="input_appN" class="form__label">Colonia:</label>
                          <input type="text" id="input_appN" class="form__input" :value="addressBenef[0].colony"
                            disabled />
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].address.street" md="4">
                          <label for="input_appN" class="form__label">Calle:</label>
                          <input type="text" id="input_appN" class="form__input" :value="spouseData[0].address.street"
                            disabled />
                        </mdb-col>
                        <mdb-col v-if="spouseData[0].address.externalNumber" md="2">
                          <label for="input_appN" class="form__label">No. Ext.:</label>
                          <input type="text" id="input_appN" class="form__input"
                            :value="spouseData[0].address.externalNumber" disabled />
                        </mdb-col>
                        <mdb-col md="2">
                          <label for="input_appN" class="form__label">No. Int.:</label>
                          <input type="text" id="input_appN" class="form__input"
                            :value="spouseData[0].address.interiorNumber" disabled />
                        </mdb-col>
                      </mdb-row>
                      <mdb-row class="mt-3">
                        <mdb-col md="8">

                          <Btn v-if="spouseProofAddress.publicURL" :text="'Comprobante de domicilio'" icon="revisar"
                            :type="'primary-admin'" @onClick="
                            openModal(spouseProofAddress.publicURL, 'Comprobante de domicilio')"></Btn>
                          <button v-if="spouseProofAddress.publicURL" type="button" class="btn btn-delete"
                            @click="spouseProofAddress.publicURL = null"
                            style="padding: 3px; position: inherit; top: 4px">
                            <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                          </button>
                          <div v-else>
                            <label for="spouse-input" class="btn-label">
                              <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                              SUBIR NUEVO COMPROBANTE
                            </label>
                            <input type="file" accept="application/pdf" name="file" id="spouse-input"
                              style="visibility: hidden" @change="uploadDocument(spouseProofAddress, $event)" />
                          </div>

                        </mdb-col>
                      </mdb-row>
                    </mdb-col>
                  </mdb-row>
                </div>

                <div v-for="(item, index) in spouseData[0].phones" :key="index">
                  <div v-if="item.phoneType == 'Emergency'" class="accordion-header">
                    Contacto de emergencia
                  </div>
                  <div v-if="item.phoneType == 'Emergency'" class="accordion-content">
                    <mdb-row>
                      <mdb-col md="12">
                        <mdb-row>
                          <mdb-col md="12">
                            <label for="input_appN" class="form__label">Nombre del contacto:</label>
                            <input type="text" id="input_appN" class="form__input" :value="item.contactName" disabled />
                          </mdb-col>
                        </mdb-row>
                        <mdb-row class="mt-3">
                          <mdb-col md="4">
                            <label for="input_appN" class="form__label">Parentesco:</label>
                            <input type="text" id="input_appN" class="form__input" :value="item.contactRelationship"
                              disabled />
                          </mdb-col>
                          <mdb-col md="4">
                            <label for="input_appN" class="form__label">Télefono celular:</label>
                            <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber" disabled />
                          </mdb-col>
                        </mdb-row>
                      </mdb-col>
                    </mdb-row>
                  </div>
                </div>
              </div>
            </Accordion>

            <!-- BENEFICIARIOS-->
            <div v-if="beneficiaries != null">
              <div v-for="(benef, index) in beneficiaries" :key="benef.id">
                <Accordion id="beneficiarios" :index="index" :key="benef.id" :title="
                  benef.beneficiaryType == 'OLDER_CHILD'
                    ? 'Hij@ mayor'
                    : 'Hij@ menor'
                ">
                  <div class="accordion-header">Personales</div>
                  <div class="accordion-content">
                    <mdb-row>
                      <mdb-col md="12">
                        <mdb-row>
                          <mdb-col md="4">
                            <div v-for="(item, index2) in beneficiariesDocs[index].documents" :key="item.id">
                              <div v-if="item.documentType == 'PROFILE_PICTURE'" class="image-upload input-group mb-5">
                                <img :src="item.publicURL" class="avatar-pic" alt="Profile Picture" />
                                <img :src="'/img/icons/editar-foto.svg'" class="edit-pic" alt="Profile Picture"
                                  style="cursor: pointer" @click="
                                    indexBenef = index;
                                  indexDoc = index2
                                  $refs.camera.toggleModal();
                                  $refs.webcam.start();" />
                              </div>
                            </div>
                          </mdb-col>
                          <mdb-col v-if="benef.birthDate" md="4">
                            <label for="input_appN" class="form__label">Fecha de nacimiento:</label>
                            <input type="text" id="input_appN" class="form__input" v-model="benef.birthDate" disabled />
                          </mdb-col>
                          <mdb-col v-if="benef.birthPlace" md="4">
                            <label for="input_appN" class="form__label">Entidad de nacimiento:</label>
                            <input type="text" id="input_appN" class="form__input" :value="benef.birthPlace" disabled />
                          </mdb-col>
                        </mdb-row>
                        <mdb-row class="mt-3">
                          <mdb-col v-if="benef.name" md="4">
                            <label for="input_name" class="form__label">Nombre:</label>
                            <input type="text" id="input_name" class="form__input" :value="benef.name" disabled />
                          </mdb-col>
                          <mdb-col v-if="benef.lastName" md="4">
                            <label for="input_lastname" class="form__label">Apellido paterno:</label>
                            <input type="text" id="input_lastname" class="form__input" :value="benef.lastName"
                              disabled />
                          </mdb-col>
                          <mdb-col v-if="benef.mothersLastName" md="4">
                            <label for="input_lastname" class="form__label">Apellido materno:</label>
                            <input type="text" id="input_lastname" class="form__input" :value="benef.mothersLastName"
                              disabled />
                          </mdb-col>
                        </mdb-row>
                        <mdb-row class="mt-3">

                          <mdb-col md="6">
                            <div v-for="item in benef.documents" :key="item.id">
                              <label v-if="item.documentType == 'CURP'" for="input_name"
                                class="form__label">CURP:</label>
                              <input v-if="item.documentType == 'CURP'" type="text" id="input_name" :value="item.value"
                                class="form__input" disabled />
                            </div>
                          </mdb-col>
                          <mdb-col md="4"></mdb-col>
                        </mdb-row>

                        <mdb-row class="mt-3">
                          <mdb-col md="4">
                            <div v-for="item in beneficiariesDocs[index].documents" :key="item.id">
                              <Btn v-if="
                              (item.documentType == 'INE' ||
                                item.documentType == 'PASSPORT') &&
                              item.publicURL != null" :text="'IDENTIFIACIÓN OFICIAL'" icon="revisar"
                                :type="'primary-admin'" @onClick="
                                openModal(item.publicURL, 'Indentificación')"></Btn>

                              <button v-if="
                                (item.documentType == 'INE' ||
                                  item.documentType == 'PASSPORT') &&
                                item.publicURL != null
                              " type="button" class="btn btn-delete" @click="item.publicURL = null"
                                style="padding: 3px; position: inherit; top: 4px">
                                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                              </button>
                              <div v-if="
                              (item.documentType == 'INE' ||
                                item.documentType == 'PASSPORT') &&
                              item.publicURL == null">
                                <label for="spouse-input" class="btn-label">
                                  <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                                  SUBIR NUEVA IDENTIFICACIÓN
                                </label>
                                <input type="file" accept="application/pdf" name="file" id="spouse-input"
                                  style="visibility: hidden" @change="uploadDocument(item, $event)" />
                              </div>


                            </div>
                          </mdb-col>
                          <mdb-col md="3">
                            <div v-for="item in benef.documents" :key="item.id">
                              <Btn v-if="item.documentType == 'CURP' && item.publicURL != null" :text="'CURP'"
                                icon="revisar" :type="'primary-admin'" @onClick="openModal(item.publicURL, 'CURP')">
                              </Btn>
                              <button v-if="item.documentType == 'CURP' && item.publicURL != null" type="button"
                                class="btn btn-delete" @click="item.publicURL = null"
                                style="padding: 3px; position: inherit; top: 4px">
                                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                              </button>
                              <div v-if="item.documentType == 'CURP' && item.publicURL == null">
                                <label for="spouse-input" class="btn-label">
                                  <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                                  SUBIR NUEVA CURP
                                </label>
                                <input type="file" accept="application/pdf" name="file" id="spouse-input"
                                  style="visibility: hidden" @change="uploadDocument(item, $event)" />
                              </div>

                            </div>
                          </mdb-col>
                          <mdb-col md="5">
                            <div v-for="item in benef.documents" :key="item.id">
                              <Btn v-if="item.documentType == 'BIRTH_CERTIFICATE' && item.publicURL != null"
                                :text="'ACTA DE NACIMIENTO'" icon="revisar" :type="'primary-admin'" @onClick="
                                  openModal(
                                    item.publicURL,
                                    'Acta de nacimiento'
                                  )
                                "></Btn>
                              <button v-if="item.documentType == 'BIRTH_CERTIFICATE' && item.publicURL != null"
                                type="button" class="btn btn-delete" @click="item.publicURL = null"
                                style="padding: 3px; position: inherit; top: 4px">
                                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                              </button>
                              <div v-if="item.documentType == 'BIRTH_CERTIFICATE' && item.publicURL == null">
                                <label for="spouse-input" class="btn-label">
                                  <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                                  SUBIR NUEVA ACTA
                                </label>
                                <input type="file" accept="application/pdf" name="file" id="spouse-input"
                                  style="visibility: hidden" @change="uploadDocument(item, $event)" />
                              </div>
                            </div>
                          </mdb-col>
                        </mdb-row>
                      </mdb-col>
                    </mdb-row>
                  </div>

                  <div v-if="addressBenef.length > 1 && benef.address" class="accordion-header">
                    Domicilio
                  </div>
                  <div v-if="addressBenef.length > 1 && benef.address" class="accordion-content">
                    <mdb-row>
                      <mdb-col md="12">
                        <mdb-row>
                          <mdb-col md="4">
                            <label for="input_appN" class="form__label">Estado:</label>
                            <input type="text" id="input_appN" class="form__input"
                              :value="addressBenef[index].state" disabled />
                          </mdb-col>

                          <mdb-col md="4">
                            <label for="input_appN" class="form__label">Ciudad:</label>
                            <input type="text" id="input_appN" class="form__input" :value="addressBenef[index].city"
                              disabled />
                          </mdb-col>
                          <mdb-col md="2">
                            <label for="input_appN" class="form__label">C. P.:</label>
                            <input type="text" id="input_appN" class="form__input"
                              :value="addressBenef[index].zipCode" disabled />
                          </mdb-col>
                        </mdb-row>
                        <mdb-row class="mt-3">
                          <mdb-col md="4">
                            <label for="input_appN" class="form__label">Colonia:</label>
                            <input type="text" id="input_appN" class="form__input"
                              :value="addressBenef[index].colony" disabled />
                          </mdb-col>
                          <mdb-col v-if="benef.address.street" md="4">
                            <label for="input_appN" class="form__label">Calle:</label>
                            <input type="text" id="input_appN" class="form__input" :value="benef.address.street"
                              disabled />
                          </mdb-col>
                          <mdb-col v-if="benef.address.externalNumber" md="2">
                            <label for="input_appN" class="form__label">No. Ext.:</label>
                            <input type="text" id="input_appN" class="form__input" :value="benef.address.externalNumber"
                              disabled />
                          </mdb-col>
                          <mdb-col md="2">
                            <label for="input_appN" class="form__label">No. Int.:</label>
                            <input type="text" id="input_appN" class="form__input" :value="benef.address.interiorNumber"
                              disabled />
                          </mdb-col>
                        </mdb-row>
                        <mdb-row class="mt-3">
                          <mdb-col md="8">
                            <div v-for="item in beneficiariesDocs[index].documents" :key="item.id">
                              <Btn v-if="item.documentType == 'PROOF_OF_ADDRESS' && item.publicURL != null"
                                :text="'Comprobante de domicilio'" icon="revisar" :type="'primary-admin'" @onClick="
                                  openModal(
                                    item.publicURL,
                                    'Comprobante de domicilio'
                                  )
                                "></Btn>
                              <button v-if="item.documentType == 'PROOF_OF_ADDRESS' && item.publicURL != null"
                                type="button" class="btn btn-delete" @click="item.publicURL = null"
                                style="padding: 3px; position: inherit; top: 4px">
                                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                              </button>
                              <div v-if="item.documentType == 'PROOF_OF_ADDRESS' && item.publicURL == null">
                                <label for="spouse-input" class="btn-label">
                                  <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                                  SUBIR NUEVO COMPROBANTE
                                </label>
                                <input type="file" accept="application/pdf" name="file" id="spouse-input"
                                  style="visibility: hidden" @change="uploadDocument(item, $event)" />
                              </div>

                            </div>
                          </mdb-col>
                        </mdb-row>
                      </mdb-col>
                    </mdb-row>
                  </div>

                  <AccordionAdmin v-if="benef.personalMail" title="De contacto" id="titularCon" style="padding: 0">
                    <div class="accordion-content">
                      <mdb-row>
                        <mdb-col md="12">
                          <mdb-row>
                            <mdb-col md="8">
                              <label for="input_appN" class="form__label">Correo electrónico:</label>
                              <input type="text" id="input_appN" class="form__input" v-model="benef.personalMail"
                                disabled />
                            </mdb-col>
                          </mdb-row>
                          <mdb-row class="mt-3">
                            <div v-for="(item, index) in benef.phones" :key="index">
                              <mdb-col md="9" v-if="item.phoneType == 'Celular'">
                                <label for="input_appN" class="form__label">Télefono celular:</label>
                                <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber"
                                  disabled />
                              </mdb-col>
                              <mdb-col v-if="item.phoneType == 'Casa'" md="9">
                                <label for="input_appN" class="form__label">Télefono casa:</label>
                                <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber"
                                  disabled />
                              </mdb-col>
                              <mdb-col v-if="item.phoneType == 'Oficina'" md="9">
                                <label for="input_appN" class="form__label">Télefono oficina:</label>
                                <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber"
                                  disabled />
                              </mdb-col>
                            </div>
                          </mdb-row>
                        </mdb-col>
                      </mdb-row>
                    </div>
                  </AccordionAdmin>

                  <div v-for="(item, index) in benef.phones" :key="index">
                    <div v-if="item.phoneType == 'Emergency'" class="accordion-header">
                      Contacto de emergencia
                    </div>
                    <div v-if="item.phoneType == 'Emergency'" class="accordion-content">
                      <mdb-row>
                        <mdb-col md="12">
                          <mdb-row>
                            <mdb-col md="12">
                              <label for="input_appN" class="form__label">Nombre del contacto:</label>
                              <input type="text" id="input_appN" class="form__input" :value="item.contactName"
                                disabled />
                            </mdb-col>


                          </mdb-row>
                          <mdb-row class="mt-3">
                            <mdb-col md="4">
                              <label for="input_appN" class="form__label">Parentesco:</label>
                              <input type="text" id="input_appN" class="form__input" :value="item.contactRelationship"
                                disabled />
                            </mdb-col>
                            <mdb-col md="4">
                              <label for="input_appN" class="form__label">Télefono celular:</label>
                              <input type="text" id="input_appN" class="form__input" :value="item.phoneNumber"
                                disabled />
                            </mdb-col>
                          </mdb-row>
                        </mdb-col>
                      </mdb-row>
                    </div>
                  </div>

                  <div v-if="beneficiariesDocs[index].laborData" class="accordion-header">
                    Datos laborales
                  </div>
                  <div v-if="beneficiariesDocs[index].laborData" class="accordion-content">
                    <mdb-row>
                      <mdb-col md="12">
                        <mdb-row>
                          <mdb-col v-if="beneficiariesDocs[index].laborData.company" md="8">
                            <label for="input_appN" class="form__label">Nombre de la empresa o lugar de trabajo:</label>
                            <input type="text" id="input_appN" class="form__input"
                              v-model="beneficiariesDocs[index].laborData.company" />
                          </mdb-col>
                          <mdb-col v-if="beneficiariesDocs[index].laborData.phone" md="4">
                            <label for="input_appN" class="form__label">Teléfono de la empresa:</label>
                            <input type="text" id="input_appN" class="form__input"
                              v-model="beneficiariesDocs[index].laborData.phone" />
                          </mdb-col>
                        </mdb-row>
                        <mdb-row class="mt-3">
                          <mdb-col v-if="beneficiariesDocs[index].laborData.position" md="8">
                            <label for="input_appN" class="form__label">Puesto que desempeña:</label>
                            <input type="text" id="input_appN" class="form__input"
                              v-model="beneficiariesDocs[index].laborData.position" />
                          </mdb-col>
                          <mdb-col md="4"></mdb-col>
                        </mdb-row>

                        <mdb-row class="mt-3">
                          <mdb-col md="6">
                            <div v-for="item in beneficiariesDocs[index].documents" :key="item.id">
                              <Btn v-if="item.documentType == 'TAX_STATUS_LETTER' && item.publicURL != null"
                                :text="'CONSTANCIA DE SITUACIÓN FISCAL'" icon="revisar" :type="'primary-admin'"
                                @onClick="
                                  openModal(
                                    item.publicURL,
                                    'Constancia de situación fiscal'
                                  )
                                "></Btn>
                              <button v-if="item.documentType == 'TAX_STATUS_LETTER' && item.publicURL != null"
                                type="button" class="btn btn-delete" @click="item.publicURL = null"
                                style="padding: 3px; position: inherit; top: 4px">
                                <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                              </button>
                              <div v-if="item.documentType == 'TAX_STATUS_LETTER' && item.publicURL == null">
                                <label for="spouse-input" class="btn-label">
                                  <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                                  SUBIR NUEVA CONSTANCIA
                                </label>
                                <input type="file" accept="application/pdf" name="file" id="spouse-input"
                                  style="visibility: hidden" @change="uploadDocument(item, $event)" />
                              </div>
                            </div>
                          </mdb-col>
                        </mdb-row>
                      </mdb-col>
                    </mdb-row>
                  </div>
                </Accordion>
              </div>
            </div>

            <div v-if="app.cars != null">
              <div v-for="(car, index) in carData" :key="car.id">
                <Accordion id="Autos" :index="index" :key="car.id" :title="'Auto' + (index + 1)">
                  <div class="accordion-header">Datos automovil</div>
                  <div class="accordion-content">
                    <mdb-row>
                      <mdb-col md="4" style="margin-bottom: 10px">
                        <div class="form__group">
                          <label for="brand" class="form__label">Marca:</label>
                          <input type="text" id="brand" v-model="car.brand" class="form__input" />
                        </div>
                      </mdb-col>
                    </mdb-row>
                    <mdb-row>
                      <mdb-col md="4" style="margin-bottom: 10px">
                        <div class="form__group">
                          <div class="form__group">
                            <label class="form__label">Modelo:</label>
                            <input type="text" v-model="car.model" class="form__input" value="" />
                          </div>
                        </div>
                      </mdb-col>
                    </mdb-row>

                    <mdb-row>
                      <mdb-col md="4" style="margin-bottom: 10px">
                        <div class="form__group">
                          <label class="form__label">Año:</label>
                          <input type="text" v-model="car.year" class="form__input" />
                        </div>
                      </mdb-col>
                    </mdb-row>




                    <mdb-row class="mt-3">
                      <mdb-col md="8">

                        <Btn v-if="carData[index].carBill.publicURL" :text="'Factura de automovil'" icon="revisar"
                          :type="'primary-admin'" @onClick="
                            openModal(carData[index].carBill.publicURL, 'Factura de automovil')
                          "></Btn>
                        <button v-if="carData[index].carBill.publicURL" type="button" class="btn btn-delete"
                          @click="carData[index].carBill.publicURL = null"
                          style="padding: 3px; position: inherit; top: 4px">
                          <img :src="'/img/icons/InoBorrar.svg'" alt="icon eliminar" />
                        </button>
                        <div v-else>
                          <label for="curp-input" class="btn-label">
                            <img :src="'/img/icons/upload-document.svg'" style="width: 20px" />
                            SUBIR NUEVA FACTURA
                          </label>
                          <input type="file" accept="application/pdf" name="file" id="curp-input"
                            style="visibility: hidden" @change="uploadDocument(carData[index].carBill, $event)" />
                        </div>

                      </mdb-col>
                    </mdb-row>
                  </div>
                </Accordion>
              </div>
            </div>
          </div>
        </div>

        <mdb-row class="mt-5">
          <mdb-col>
            <div class="btn-submit-docs">
              <!-- saveBenaficiaryData-->

              <Btn style="display: inline" :type="'primary-block'" :text="'ENVIAR DATOS/DOCUMENTOS ACTUALIZADOS'"
                @onClick="beforeSend" />
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
    <Popup size="md-mod2" ref="profile" :title="titleModal">
      <div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 95%">
        <iframe title="titulo" class="embed-responsive-item" :src="popUrl" allowfullscreen></iframe>
      </div>
      <div class="accordion__button">
        <btn style="float: left" text="CERRAR" @onClick="$refs.profile.toggleModal()" type="primary-block" />
      </div>
    </Popup>

    <Popup ref="camera" size="md">
      <div class="text-center">
        <mdb-row>
          <mdb-col md="6">
            <mdb-row>
              <h2>Cámara</h2>
              <div class="border">
                <vue-web-cam ref="webcam" :device-id="deviceId" width="100%" height="100%" @started="onStarted"
                  @stopped="onStopped" @error="onError" @cameras="onCameras" @camera-change="onCameraChange" />
              </div>
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <select v-model="camera">
                  <option>-- Selecciona cámara --</option>
                  <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">
                    {{ device.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="onCapture">
                  Tomar foto
                </button>
              </div>
            </mdb-row>
          </mdb-col>
          <mdb-col v-if="imgSrc" md="6">
            <mdb-row>
              <h2>Foto Capturada</h2>
              <vue-cropper ref="cropper" :aspect-ratio="9 / 9" :src="imgSrc" preview=".preview" />
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="cropImage">
                  Recortar
                </button>
              </div>
            </mdb-row>
          </mdb-col>
          <mdb-col v-if="imgSrc" md="12">
            <mdb-row>
              <div class="col-md-12">
                <h2>Vista Previa</h2>
                <div class="image-upload">
                  <label for="image-release">
                    <img :src="imgSrc" class="avatar-pic" alt="Profile Picture" style="cursor: pointer" />
                  </label>
                </div>
              </div>
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <button type="button" class="btn btn-primary" @click="
                  $refs.camera.toggleModal();
                $refs.webcam.stop();
                indexBenef = null
                indexDoc = null
                ">
                  Finalizar edición
                </button>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>

    <Loader v-show="isLoading" />
  </div>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
import Input from "../../core/Input";
import Btn from "../../core/Button";
import Popup from "../../core/Popup";
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import Loader from "../../core/Loader";
import Accordion from "../../core/Accordion";
import AccordionAdmin from "../../core/AccordionAdmin";
import AccordionHeader from "../../core/Accordion/Header";
import { WebCam } from "vue-web-cam";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  name: "UpdateRemainig",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    Btn,
    Input,
    Popup,
    Loader,
    Accordion,
    AccordionAdmin,
    AccordionHeader,
    "vue-web-cam": WebCam,
    VueCropper,
  },
  data() {
    return {
      isLoading: false,
      imgSrc: null,
      camera: null,
      deviceId: null,
      devices: [],
      marital: "CASADO",
      addressBenef: [],
      titleModal: "",
      popUrl: "",
      //TITULAR
      titularProofAddress: {
        id: "",
        publicURL: "",
        content: "",
        documentType: "PROOF_OF_ADDRESS",
      },
      billingInformation: {},
      //CONYUGE
      spouseProofAddress: {
        id: "",
        publicURL: "",
        content: "",
        documentType: "PROOF_OF_ADDRESS",
      },
      //BENEFICIARIOS
      beneficiariesDocs: [],
      indexBenef: null,
      indexDoc: null,
      //Autos
      carData: [],
    };
  },
  methods: {
    ...mapActions([
      "obtainAddress",
      "obtainAddressBeneficiaries",
      "obtainAddressBill",
      "updateTitular",
      "updateBeneficiaries",
    ]),
    async beforeSend() {
      let titularData = {
        documents: [],
        cars: []
      }
      let beneficiariesData = []

      if (this.app.billingInformation.comment) {
        titularData.billingInformation = this.billingInformation
      }

      // for (let index in this.carData){

      //   titularData.cars.push({
      //     "id": this.carData[index].id,
      //   "brand": this.carData[index].brand,
      //   "model": this.carData[index].model,
      //   "year": this.carData[index].year

      //   })
      //   if(this.carData[index].carBill.content != ''){
      //    titularData.documents.push({
      //       id: this.carData[index].carBill.id,
      //       documentType: "CAR_BILL",
      //       value: this.carData[index].carBill.value,
      //       extension: "pdf",
      //       mimeType: "application/pdf",
      //       content: this.carData[index].carBill.content
      //     });
      //   }
      // }

      if (this.titularProofAddress.content != '') {
        titularData.documents.push({
          id: this.titularProofAddress.id,
          documentType: "PROOF_OF_ADDRESS",
          value: "",
          extension: "pdf",
          mimeType: "application/pdf",
          content: this.titularProofAddress.content
        });
      }


      if (this.spouse) {

        if (this.spouseProofAddress.content != '') {

          let data = {
            id: this.spouseData[0].id,
            beneficiaryType: "SPOUSE",
            documents: [
              {
                id: this.spouseProofAddress.id,
                documentType: "PROOF_OF_ADDRESS",
                value: "",
                extension: "pdf",
                mimeType: "application/pdf",
                content: this.spouseProofAddress.content
              }

            ]

          }
          beneficiariesData.push(data)
        }
      }

      if (this.beneficiaries) {
        for (let index in this.beneficiariesDocs) {
          let aux = {}


          if (this.beneficiariesDocs[index].laborData) {
            ///HIJO MAYOR
            aux.laborData = this.beneficiariesDocs[index].laborData
            aux.id = this.beneficiariesDocs[index].id
            aux.beneficiaryType = this.beneficiariesDocs[index].beneficiaryType
            aux.documents = []
          }
          else {
            ///HIJO MENOR
            aux.id = this.beneficiariesDocs[index].id
            aux.beneficiaryType = this.beneficiariesDocs[index].beneficiaryType
            aux.documents = []

          }

          for (let index2 in this.beneficiariesDocs[index].documents) {
            if (this.beneficiariesDocs[index].documents[index2].content != '') {
              aux.laborData = this.beneficiariesDocs[index].laborData
              aux.id = this.beneficiariesDocs[index].id
              aux.beneficiaryType = this.beneficiariesDocs[index].beneficiaryType
              aux.documents.push(this.beneficiariesDocs[index].documents[index2])
            }
          }

          beneficiariesData.push(aux)


        }
      }
      //console.log(titularData)
      //console.log({beneficiaries:beneficiariesData})


      try {
        this.isLoading = true;
        let response = await this.updateTitular(titularData);
        this.isLoading = false;
        if (response.data.status == 200 || response.data.status == 201) {
          if (beneficiariesData.length > 0) {
            await this.updateBeneficiaries({ beneficiaries: beneficiariesData })
          }
          else {
            await this.updateBeneficiaries({ beneficiaries: [] })
          }
          Swal.fire({
            title:
              "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #828282'>¡ACTUALIZACIÓN REALIZADA!</span>",
            html:
              "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
              "<p>Gracias por actualizar tus datos/documentos. Ahora el proceso de trámite de admisión podrá continuar, espera respuesta del Club. Revisa tu correo constantemente.</p>" +
              // "<p style='padding-top: 1rem;'>El tiempo de espera de respuesta es de tres semanas aproximadamente, contando desde el día que realizas tu pago</p>" +
              "<p style='padding-top: 1rem;'>Toma en cuenta que las correcciones que realices por documentos o datos incorrectos enviados hace que el proceso demore un poco más.</p>" +
              "</div>",
            allowOutsideClick: false,
            width: "50rem",
            padding: "2rem",
            confirmButtonText: "OK",
            confirmButtonColor: "#dc7134",
            customClass: {
              confirmButton: "t1-btn t1-btn--primary-block",
            },
            onClose: () => { },
          }).then((result) => {
            this.$router.push("/home");
          });

        }
      } catch (error) {
        this.isLoading = false;
        //console.log(error);
        // this.$notify.error({
        //   message: error.response.data.errorDetails,
        //   position: "top right",
        //   timeOut: 15000,
        // });
      }




    },
    async beforeEnter() {
      if (this.app != null) {
        if (this.app.maritalStatus == "MARRIED") {
          this.marital = "CASADO";
        }
        if (this.app.maritalStatus == "SINGLE") {
          this.marital = "SOLTERO";
        }
        if (this.app.maritalStatus == "DIVORCED") {
          this.marital = "DIVORCIADO";
        }
        if (this.app.maritalStatus == "WIDOWED") {
          this.marital = "VIUDO";
        }
      }

      if (this.app.address != null) {
        let res = await this.obtainAddress(this.app.address.location.id);

        if (this.app.billingInformation) {
          await this.obtainAddressBill(
            this.app.billingInformation.address.location.id
          );
        }

        this.addressBenef = [];
        for (let index = 0; index < this.app.beneficiaries.length; index++) {
          let benef = this.app.beneficiaries[index];

          if (benef.address != null) {
            let response = await this.obtainAddressBeneficiaries(
              benef.address.location.id
            );

            let aux = {};
            aux.state = response.state;
            aux.city = response.city;
            aux.colony = response.colony;
            aux.zipCode = response.zipCode;
            this.addressBenef.push(aux);
          }
        }
      }
      /////////////////// DATA EDIT///////////////
      let comprobanteDomicilio = this.app.documents.filter(function (item) { return item.documentType == 'PROOF_OF_ADDRESS' })
      this.titularProofAddress.id = comprobanteDomicilio[0].id
      this.titularProofAddress.publicURL = comprobanteDomicilio[0].publicURL

      this.billingInformation = this.app.billingInformation;

      if (this.spouseData) {
        comprobanteDomicilio = this.spouseData[0].documents.filter(function (item) { return item.documentType == 'PROOF_OF_ADDRESS' })
        this.spouseProofAddress.id = comprobanteDomicilio[0].id
        this.spouseProofAddress.publicURL = comprobanteDomicilio[0].publicURL
      }

      for (let index in this.app.cars) {
        let plate = this.app.cars[index].plates
        let car = this.app.documents.filter(function (item) { return item.documentType == 'CAR_BILL' && item.value.toLocaleLowerCase() == plate.toLocaleLowerCase() })

        let aux =
        {
          id: this.app.cars[index].id,
          brand: this.app.cars[index].brand,
          model: this.app.cars[index].model,
          year: this.app.cars[index].year,
          carBill: {
            id: car[0].id,
            publicURL: car[0].publicURL,
            value: car[0].value,
            content: "",
          }
        };

        this.carData.push(aux)
      }

      if (this.beneficiaries != null) {
        for (let index in this.beneficiaries) {

          let docs = [];

          for (let index_doc in this.beneficiaries[index].documents) {
            let docAux = {
              id: this.beneficiaries[index].documents[index_doc].id,
              documentType: this.beneficiaries[index].documents[index_doc].documentType,
              value: this.beneficiaries[index].documents[index_doc].value,
              publicURL: this.beneficiaries[index].documents[index_doc].publicURL,
              content: "",
            };
            docs.push(docAux)

          }
          let aux = {
            id: this.beneficiaries[index].id,
            beneficiaryType: this.beneficiaries[index].beneficiaryType,
            laborData: this.beneficiaries[index].laborData,
            documents: docs
          };

          this.beneficiariesDocs.push(aux)
        }
      }





    },
    openModal(url, title) {
      this.popUrl = url;
      this.titleModal = title;
      this.$refs.profile.toggleModal();
    },
    uploadDocument(object, evt) {
      object.publicURL = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        object.content = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);

    },
    onCapture() {
      this.imgSrc = this.$refs.webcam.capture();
      this.$refs.cropper.replace(this.imgSrc);
      //this.$refs.camera.toggleModal();
      //this.$refs.webcam.stop();
      //this.fileAvatar = this.imgSrc;
    },
    onStarted(stream) {
      //console.log("On Started Event", stream);
    },
    onStopped(stream) {
      //console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      //console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      //console.log("On Camera Change Event", deviceId);
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      //console.log(this.indexBenef)
      //console.log(this.indexDoc)
      this.imgSrc = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.beneficiariesDocs[this.indexBenef].documents[this.indexDoc].publicURL = this.imgSrc;
      this.beneficiariesDocs[this.indexBenef].documents[this.indexDoc].content = this.imgSrc.split(",")[1];
      //console.log(this.beneficiariesDocs)
    },
    reset() {
      this.$refs.cropper.reset();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
  },
  computed: {
    ...mapGetters({
      app: "getAllApplicationData",
      addressT: "getAddressT",
      addressBill: "getAddressBill",
    }),
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
    beneficiaries() {
      if (this.app.beneficiaries.length > 1) {
        return this.app.beneficiaries.filter(function (item) {
          return item.beneficiaryType != "SPOUSE";
        });
      } else {
        return null;
      }
    },
    spouseData() {
      if (this.app.beneficiaries.length > 0) {
        let spouse = this.app.beneficiaries.filter(function (item) {
          return item.beneficiaryType == "SPOUSE";
        });
        
        if (spouse.length === 0) return null

        let investigation1 = spouse[0].documents.filter(function (item) {
          return item.documentType == "EXTRA_INVESTIGATION";
        });

        if (investigation1.length > 0) {
          this.fileConExtra = investigation1[0].publicURL;
        }

        return spouse;
      } else {
        return null;
      }
    },
    edad() {
      var aux = this.app.birthDate.split("-");
      var año = aux[2];
      var mes = aux[1];
      var dia = aux[0];
      var date1 = new Date(año + "-" + mes + "-" + dia);

      var diff_ms = Date.now() - date1.getTime();
      var age_dt = new Date(diff_ms);
      var age_dt = new Date(diff_ms);
      var age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
  },
  async mounted() {
    window.scroll(0, 0);
    await this.beforeEnter();
  },
  created() { },
  updated() { },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  }
};
</script>

<style lang="scss">
.btn-add-right {
  position: relative;
  padding-right: 12rem;
  text-align: right;

  @media (max-width: 50rem) {
    padding-right: 2rem;
  }
}

.btn-submit-docs {
  padding-right: 12rem;
  padding-top: 3rem;
  padding-bottom: 6rem;
  text-align: right;

  @media (max-width: 50rem) {
    padding-right: 2rem;
  }
}

.documents-section {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.documents-section .accordion-header {
  background-color: #3a8a65;
  width: 100%;
  height: auto;
  color: #fff;
  text-align: left;
  font-weight: 600;
  font-size: 1.8rem;
  margin-left: auto;
  margin-right: auto;
  padding: 1.5rem 2rem;
  border-radius: 0.5rem;
}

.documents-section .accordion-content {
  width: 100%;
  height: auto;
  margin: 0 auto;
  margin-bottom: 40px;
  background: #fff;
  padding: 20px 20px 20px 20px;
  border-radius: 0.5rem;
}

.documents-section .info {
  width: 80%;
  height: auto;
  margin: 0 auto;
}

.accordion-section {
  width: 85%;
  height: auto;
  margin: 0 auto;
  padding-bottom: 20px;
}

.accordion-section .content-info {
  width: 95%;
  height: auto;
  margin: 0 auto;
  padding: 50px 31px 0px 31px;
  background: #fff;
  padding-bottom: 20px;
}

.custom-btn-saved {
  color: #f78c4f;
  background-color: #fff !important;
}

.btn-section {
  width: 80%;
  height: auto;
  margin: 0 auto;
  padding-bottom: 20px;
}

.btn-show-child {
  width: 200px;
  height: auto;
  float: right;
}

.btn-add-child {
  margin-top: 20px;
}

.title-pop-child {
  font-weight: 600;
  color: #dc7134;
  margin-bottom: 20px;
}

.subtitle-pop-child {
  font-size: 18px;
  line-height: 22px;
  color: #285f46;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.text-pop-child {
  display: block;
  font-size: 1.4rem;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.radio-buttons label {
  display: block;
  color: #828282;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-right: 15px;
}

.custom-control-input:checked~.custom-control-label::before {
  color: #fff;
  border-color: #f78c4f;
  background-color: #f78c4f;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 15px;
  height: 15px;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.text-style {
  font-size: 27px;
  color: #285f46;
  font-weight: 600;
  text-transform: uppercase;
}

.divLine {
  width: 100%;
  border: 0.1rem solid #828282;
}

.Rectangle-78 {
  width: 100%;
  padding: 1rem;
  height: 100%;
  border: 1px solid #285f46;
}

.avatar-pic {
  /* position: absolute; */
  border: 0.6rem solid #285f46;
  border-radius: 50%;
  width: 10rem;
  height: 10rem;
}

.btn-delete {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.btn-delete:hover {
  background-color: #eb5757 !important;
}

.btn-delete:active {
  background-color: #d65050 !important;
}

.btn-label {
  border-radius: 5px;
  background-color: #dc7134;
  padding: 0.4rem 2.5rem;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  font-weight: 600;
  font-family: Josefin Sans;
  cursor: pointer;
}

.edit-pic {
  cursor: pointer;
  position: absolute;
  z-index: 100;
}

.avatar-pic {
  /* position: absolute; */
  /* border: 0.6rem solid #285f46; */
  border-radius: 50%;
  width: 13rem;
  height: 13rem;
}

.image-upload>input {
  display: none;
}
</style>